module.exports = __webpack_public_path__ + "static/00001.c695d085.jpg";